<div class="page-header-container">
  <md-page-header title="{{ 'NAV.END_PRODUCT_CUSTOMERS' | translate }}"></md-page-header>
</div>
